import { render, staticRenderFns } from "./PaymentsrecEdit.vue?vue&type=template&id=8ed8d22e"
import script from "./PaymentsrecEdit.vue?vue&type=script&lang=js"
export * from "./PaymentsrecEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports